module.exports = __webpack_public_path__ + "img/stockradars.8c4132ef.png";